import React from 'react';
import CommentList from '../../components/Community/CommentList/CommentList';
import SocialBar from '../../components/Community/SocialBar/SocialBar';
import SVGIconWrapper from '../../components/Icons/SVGIconWrapper/SVGIconWrapper';
import Icons from '../../components/Messages/Icons/Icons';
import { getMMDDYYTimestamp } from '../../components/Utilities/TimeFunctions';

import { Consumer as CommunityContextConsumer } from '../../contexts/CommunityContext';
import ReactionBar from '../../components/Community/ReactionBar/ReactionBar';

/**
 *
 * @deprecated
 */
export const getReactionBar = (
    elementId,
    shouldShowReactionBar,
    contentHash
) => {
    if (!shouldShowReactionBar) return;

    const goToInput = (context) => {
        context.openCommentReply(contentHash);

        const commentInput = window.document.getElementById(elementId);
        const headerOffset = 100;
        const commentInputPosition = commentInput.getBoundingClientRect().top;

        // have to add pageYOffset to accurately scroll to input on different sections of page
        const pageYOffsetPosition = window.pageYOffset;
        const offsetPosition =
            commentInputPosition - headerOffset + pageYOffsetPosition;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });
    };

    return (
        <CommunityContextConsumer>
            {(context) => (
                <SocialBar
                    {...SocialBar.contextToProps(context, contentHash)}
                    onReply={() => goToInput(context)}
                />
            )}
        </CommunityContextConsumer>
    );
};

export const renderReactionBar = (
    contentHash,
    location = 'singleContent',
    className = ''
) => (
    <ReactionBar hash={contentHash} location={location} className={className} />
);

export const renderComments = (
    content,
    MoreCommentsFunction = () => {},
    hideReactionBar = false
) => {
    return (
        <CommunityContextConsumer>
            {(context) => {
                return (
                    <CommentList
                        onFeed={false}
                        openedCommentHash={context.openedCommentHash}
                        comments={context.getContent(content.hash).comments}
                        MoreCommentsFunction={MoreCommentsFunction}
                        hideReactionBar={hideReactionBar}
                    />
                );
            }}
        </CommunityContextConsumer>
    );
};

export const renderBackToParentButton = (
    BackToPrevCommentFunction = () => {},
    isFirstLevelComments = false
) => {
    const backButtonText = isFirstLevelComments
        ? 'Return to content'
        : 'Return to reply';
    return (
        <button
            className="back-to-parent-content-button"
            onClick={BackToPrevCommentFunction}
            type="button"
        >
            <SVGIconWrapper SVGWrapperCssClass="back-caret">
                <Icons name="back-caret" />
            </SVGIconWrapper>
            {backButtonText}
        </button>
    );
};

export const renderExpandedCommentList = (
    parentTitle,
    commentToShow,
    setComment,
    BackToPrevCommentFunction,
    isFirstLevelComments = false
) => {
    return (
        <React.Fragment>
            {renderBackToParentButton(
                BackToPrevCommentFunction,
                isFirstLevelComments
            )}
            <div className="parent-link">
                {`Commented on: ${getMMDDYYTimestamp(
                    commentToShow.contentDate
                )} -`}
                <button
                    className="parent-button"
                    onClick={() => setComment()}
                    type="button"
                >
                    {parentTitle}
                </button>
            </div>
            {renderComments(commentToShow, setComment)}
            {renderBackToParentButton(
                BackToPrevCommentFunction,
                isFirstLevelComments
            )}
        </React.Fragment>
    );
};

export const getPrevLevelComment = (refs, contentHash, iteration = 0) => {
    const currentComment = refs[contentHash];
    if (!currentComment.parentHash) {
        return null;
    }

    if (iteration === 3) {
        return currentComment.parentHash;
    }

    return getPrevLevelComment(refs, currentComment.parentHash, iteration + 1);
};
